/**
 * Printora card hover — draft
 * - Prefetch secondary images when cards near viewport (no blank hover)
 * - Only swap once secondary has loaded
 * - Prefetch collection URLs for faster category switches
 */
(function () {
  'use strict';
  if (window.__printoraCardHoverV2) return;
  window.__printoraCardHoverV2 = true;

  var prefetched = Object.create(null);
  var hoverIO = null;

  function markReady(media) {
    if (!media) return;
    media.classList.add('is-hover-ready');
    media.setAttribute('data-hover-hydrated', '1');
  }

  function hydrateHoverImage(media, opts) {
    opts = opts || {};
    if (!media) return;
    if (media.getAttribute('data-hover-hydrated') === '1') {
      media.classList.add('is-hover-ready');
      return;
    }

    var img = media.querySelector('img[data-hover-src], img.card-media__hover-img');
    if (!img) {
      markReady(media);
      return;
    }

    var src = img.getAttribute('data-hover-src');
    var srcset = img.getAttribute('data-hover-srcset');

    function onReady() {
      markReady(media);
      img.style.opacity = '';
    }

    if (!src && (!img.src || img.src.indexOf('data:image') === 0)) {
      /* already missing real src */
      return;
    }

    if (src) {
      /* Don't mark ready until decode completes — prevents blank swap */
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        onReady();
      }

      img.addEventListener('load', finish, { once: true });
      img.addEventListener('error', finish, { once: true });

      img.src = src;
      if (srcset) img.srcset = srcset;
      img.removeAttribute('data-hover-src');
      img.removeAttribute('data-hover-srcset');
      img.classList.add('lazyloaded');
      img.classList.remove('lazyload', 'lazyloading');
      img.loading = 'eager';
      img.fetchPriority = opts.priority || 'low';

      if (img.complete && img.naturalWidth > 0) finish();
    } else if (img.complete && img.naturalWidth > 0) {
      onReady();
    } else {
      img.addEventListener('load', onReady, { once: true });
      img.addEventListener('error', onReady, { once: true });
    }
  }

  function observeCards() {
    var medias = document.querySelectorAll(
      '.card-media.media--hover-effect:not([data-hover-hydrated="1"])'
    );
    if (!medias.length) return;

    if (!('IntersectionObserver' in window)) {
      medias.forEach(function (m) {
        hydrateHoverImage(m, { priority: 'low' });
      });
      return;
    }

    if (!hoverIO) {
      hoverIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hydrateHoverImage(entry.target, { priority: 'low' });
            hoverIO.unobserve(entry.target);
          });
        },
        { rootMargin: '180px 0px', threshold: 0.01 }
      );
    }

    medias.forEach(function (m) {
      hoverIO.observe(m);
    });
  }

  function prefetchUrl(href) {
    if (!href || prefetched[href]) return;
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return;
      if (!u.pathname.startsWith('/collections/') && !u.pathname.startsWith('/products/')) return;
      if (u.pathname === window.location.pathname) return;
    } catch (e) {
      return;
    }
    prefetched[href] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = u.pathname + u.search;
    document.head.appendChild(link);
  }

  function onEnter(event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var media = t.closest('.card-media.media--hover-effect');
    if (media) hydrateHoverImage(media, { priority: 'high' });

    var item = t.closest('.product-item, .card-product');
    if (item) {
      var m = item.querySelector('.card-media.media--hover-effect');
      if (m) hydrateHoverImage(m, { priority: 'high' });
    }

    var a = t.closest('a[href*="/collections/"], a[href*="/products/"]');
    if (a) prefetchUrl(a.href);
  }

  document.addEventListener('pointerenter', onEnter, true);
  document.addEventListener('focusin', onEnter, true);
  /* pointerover catches scroll+hover edge cases better on some devices */
  document.addEventListener('pointerover', onEnter, true);

  function warmNav() {
    var links = document.querySelectorAll(
      '#printora-sticky-header a[href*="/collections/"], .pk-col-filters a[href*="/collections/"], .pk-cats a[href*="/collections/"], .pk-mega a[href*="/collections/"]'
    );
    var n = 0;
    for (var i = 0; i < links.length && n < 16; i++) {
      prefetchUrl(links[i].href);
      n++;
    }
  }

  function boot() {
    observeCards();
    warmNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(warmNav, { timeout: 1500 });
    requestIdleCallback(observeCards, { timeout: 2000 });
  } else {
    window.setTimeout(warmNav, 600);
    window.setTimeout(observeCards, 800);
  }

  window.addEventListener('load', function () {
    observeCards();
    warmNav();
  }, { once: true });

  /* Re-scan after infinite scroll / filter AJAX */
  document.addEventListener('shopify:section:load', observeCards);
  window.setInterval(function () {
    if (document.querySelector('.card-media.media--hover-effect:not([data-hover-hydrated="1"])')) {
      observeCards();
    }
  }, 2500);
})();

/**
 * Printora site-wide FOUC release.
 * MainContent is held by printora-nav-speed.css on non-home/non-product pages.
 * Because this file is deferred, the whole document has been parsed by the
 * time this runs, including stylesheet links emitted inside custom sections.
 */
(function () {
  'use strict';
  if (window.__printoraSiteFoucGuard) return;
  window.__printoraSiteFoucGuard = true;

  var root = document.documentElement;
  var released = false;
  var fallback = window.setTimeout(release, 3000);

  function release() {
    if (released) return;
    released = true;
    window.clearTimeout(fallback);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        root.classList.add('pk-site-css-ready');
      });
    });
  }

  function waitForStyles() {
    var links = document.querySelectorAll('link[rel~="stylesheet"]');
    var pending = [];
    var i;

    for (i = 0; i < links.length; i++) {
      if (!links[i].sheet) pending.push(links[i]);
    }

    if (!pending.length) {
      release();
      return;
    }

    var remaining = pending.length;
    function settled() {
      remaining -= 1;
      if (remaining <= 0) release();
    }

    for (i = 0; i < pending.length; i++) {
      (function (link) {
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          link.removeEventListener('load', finish);
          link.removeEventListener('error', finish);
          settled();
        }
        link.addEventListener('load', finish);
        link.addEventListener('error', finish);
        window.setTimeout(finish, 1800);
      })(pending[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForStyles, { once: true });
  } else {
    waitForStyles();
  }
})();
